/***
 * 发送统计报数
 * 简单监测下url，如果是http或者https或者是//则发送请求
 * **/
function sendUrl(url) {
    if(checkUrl(url)){
        var img = document.createElement("IMG");
        img.onload = img.onerror = function () {
            this.onload = img.onerror = null;
            document.body.removeChild(this);
        };
        img.style.position = "absolute";
        img.style.top = "-1px";
        img.style.left = "-1px";
        img.style.width = "1px";
        img.style.height = "1px";
        img.style.display = "none";
        document.body.appendChild(img);
        img.src = url;
        console.log("发送", url)
    }
}
function checkUrl(url) {
    if(url){
        if(typeof url=="function"){
            url = url();
        }
        return typeof url=="string"&&(url.substr(0,5)=="http:"||url.substr(0,6)=="https:"||url.substr(0,2)=="\/\/")
    }
    return false;
}
function sendUrls(arr) {
    for (var i = 0; i < arr.length; i++) {
        sendUrl(arr[i]);
    }
}

module.exports = sendUrls;